// @mui material components
import {
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Card,
  Grid,
  // Grid,
  // MenuItem,
  // Select,
  // FormControl,
  // InputLabel,
  // Dialog,
  // DialogContent,
  Icon,
  Divider,
  // Container,
  IconButton,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { useState } from "react";
// import axios from "axios.js";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
// import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
// import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import { useAuthUser } from "react-auth-kit";

import { useNavigate } from "react-router-dom";
// import AgentFeedback from "app/components/feedback_dialog";
// import { useEffect, useState } from "react";
// import axios from "axios.js";
import AppConfig from "appConfig";

function Dashboard() {
  const pageTitle = "Dashboard";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const auth = useAuthUser();
  const user = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setSeverity("error");
    setShowLoading(false);
  };

  const [feedbackDisplayState, setFeedbackDisplayState] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      {/* <AgentFeedback
        displayState={feedbackDisplayState}
        setDisplayState={setFeedbackDisplayState}
      /> */}

      <MDBox mb={10}>
        <MDBox>
          <MDBox m={1}>
            <MDTypography variant="h6" fontWeight="light" align="center">
              Welcome <b>{user.first_name}</b>
            </MDTypography>
          </MDBox>
        </MDBox>
        <Divider />
        <MDBox mt={1}>
          <MDBox>
            <MDBox>
              <Grid container spacing={{ xs: 3, md: 3, lg: 3 }}>
                <Grid item xs={12}>
                  <Card>
                    <MDBox
                      p={2}
                      onClick={() => {
                        navigate("/tasks");
                      }}
                    >
                      <MDBox>
                        <MDTypography variant="h6">
                          <Icon color="dark">assignment</Icon> &nbsp;Tasks
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <Icon>chevron_right</Icon>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
                {/* <Grid item xs={12}>
                  <Grid container spacing={{ xs: 2, md: 3, lg: 3 }}>
                    <Grid item xs={6} md={6} lg={6}>
                      <Card sx={{ height: "100%" }}>
                        <MDBox
                          p={2}
                          onClick={() => {
                            navigate("/sell");
                          }}
                          sx={{ height: "100%" }}
                          display="flex"
                          justifyContent="space-between"
                          flexDirection="column"
                        >
                          <MDBox>
                            <MDTypography variant="h6">
                              <Icon color="success">receipt</Icon> &nbsp; Sell
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={2}>
                            <Icon>chevron_right</Icon>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Card>
                        <MDBox
                          p={2}
                          onClick={() => {
                            navigate("/data-capture");
                          }}
                        >
                          <MDBox>
                            <MDTypography variant="h6">
                              <Icon color="info">edit_note</Icon> &nbsp;Data
                              Capture
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={2}>
                            <Icon>chevron_right</Icon>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
                
                <Grid item xs={12}>
                  <Card>
                    <MDBox
                      p={2}
                      onClick={() => {
                        navigate("/tools");
                      }}
                    >
                      <MDBox>
                        <MDTypography variant="h6">
                          <Icon color="dark">apps</Icon> &nbsp;Tools
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <Icon>chevron_right</Icon>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid> */}
                <Grid item xs={12}>
                  <Grid container spacing={{ xs: 2, md: 3, lg: 3 }}>
                    <Grid item xs={6} md={6} lg={6}>
                      <Card sx={{ height: "100%" }}>
                        <MDBox
                          p={2}
                          onClick={() => {
                            navigate("/location-check-in");
                          }}
                          sx={{ height: "100%" }}
                          display="flex"
                          justifyContent="space-between"
                          flexDirection="column"
                        >
                          <MDBox>
                            <MDTypography variant="h6">
                              <Icon color="dark">person_pin</Icon> &nbsp;Check
                              In
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={2}>
                            <Icon>chevron_right</Icon>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Card>
                        <MDBox
                          p={2}
                          onClick={() => {
                            navigate("/attendance");
                          }}
                        >
                          <MDBox>
                            <MDTypography variant="h6">
                              <Icon color="dark">assignment_ind</Icon>{" "}
                              &nbsp;Attendance
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={2}>
                            <Icon>chevron_right</Icon>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={{ xs: 2, md: 3, lg: 3 }}>
                    <Grid item xs={6} md={6} lg={6}>
                      <Card sx={{ height: "100%" }}>
                        <MDBox
                          p={2}
                          onClick={() => {
                            navigate("/courses");
                          }}
                          sx={{ height: "100%" }}
                          display="flex"
                          justifyContent="space-between"
                          flexDirection="column"
                        >
                          <MDBox>
                            <MDTypography variant="h6">
                              <Icon color="dark">school</Icon> &nbsp;Trainings
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={2}>
                            <Icon>chevron_right</Icon>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Card>
                        <MDBox
                          p={2}
                          onClick={() => {
                            navigate("/messages");
                          }}
                        >
                          <MDBox>
                            <MDTypography variant="h6">
                              <Icon color="dark">mail</Icon> &nbsp;Inbox
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={2}>
                            <Icon>chevron_right</Icon>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Card>
                    <MDBox
                      p={2}
                      onClick={() => {
                        navigate("/lead-buckets");
                      }}
                    >
                      <MDBox>
                        <MDTypography variant="h6">
                          <Icon color="dark">people</Icon> &nbsp;Leads
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <Icon>chevron_right</Icon>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
                {/* <Grid item xs={12}>
                  <Card>
                    <MDBox p={2}>
                      <MDBox>
                        <MDTypography variant="h6">
                          <Icon color="secondary">group</Icon> &nbsp;Laddar Community
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={2} display="flex" justifyContent="start" alignItems="start">
                        <a href={AppConfig.whatsapp_group_link} target="_blank" rel="noreferrer">
                          <IconButton size="large">
                            <WhatsAppIcon color="success">WhatsApp</WhatsAppIcon>
                          </IconButton>
                        </a>
                        <a href={AppConfig.telegram_group_link} target="_blank" rel="noreferrer">
                          <IconButton size="large">
                            <Icon color="info">telegram</Icon>
                          </IconButton>
                        </a>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid> */}
              </Grid>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
